import { Routes } from "@angular/router";

const scope: string = "feature/transport-management-routes";

export const TRANSPORT_MANAGEMENT_ROUTES: Routes = [
  { path: "" },
  { path: "modules" },
  {
    path: "unloading-areas-overview",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Übersicht der Entladezonen",
              token: "breadcrumb-label-overview-discharge-zones",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "despatch-advises",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Übersicht aller Transporte",
              token: "breadcrumb-label-overview-all-transports",
              scope
            }
          }
        }
      }
    },
    children: [
      {
        path: "new",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Transport Avisieren",
                  token: "breadcrumb-label-dispatch-transport",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: "unannounced",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Unangemeldeter Transport",
                  token: "breadcrumb-label-unannounced-transport",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: ":despatchAdvisesNumber",
        data: {
          context: {
            breadcrumb: {
              apiPath: "api/transport-management/projects/{projectNumber}/despatch-advices/{despatchAdvisesNumber}"
            }
          }
        }
      }
    ]
  },
  {
    path: "despatch-advise-settings",
    data: {
      leaf: true,
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Einstellungen",
              token: "breadcrumb-label-settings",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "lifting-equipment-despatch-advises",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Übersicht Hebe/Fördermittel-Avisierungen",
              token: "breadcrumb-label-overview-lifting-equipment-dispatches",
              scope
            }
          }
        }
      }
    },
    children: [
      {
        path: "new",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Hebe/Fördermittel avisieren",
                  token: "breadcrumb-label-dispatch-lifting-equipment",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: ":number",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Hebe/Fördermittel-Avisierung ANFRAGEN",
                  token: "breadcrumb-label-request-lifting-equipment-dispatch",
                  scope
                }
              }
            }
          }
        }
      }
    ]
  },
  {
    path: "lifting-equipments",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Übersicht Hebe/Fördermittel",
              token: "breadcrumb-label-overview-lifting-equipments",
              scope
            }
          }
        }
      }
    },
    children: [
      {
        path: "new",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Hebe/Fördermittel anlegen",
                  token: "breadcrumb-label-create-lifting-equipment",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: ":liftingEquipmentNumber",
        data: {
          breadcrumb: {
            apiPath: "api/equipment-management/projects/{projectNumber}/equipment-despatch-advices/{liftingEquipmentNumber}"
          }
        }
      }
    ]
  }
];
